module.exports = __webpack_public_path__ + "img/about-enterprise2.8f735fa9.png";